import { CHART_PALETTE } from '@/components/ui/chartPalette.ts';
import { STATUS_TONE_COLORS } from '@/components/ui/statusTone.ts';

/**
 * Główna ścieżka lejka, w kolejności. Pierwsze trzy progi liczą sesje
 * przeglądarki, dalsze — rekordy rezerwacji; kartę o tym podpisujemy.
 */
export enum FunnelStageKey {
  OFFER_VIEWED = 'OFFER_VIEWED',
  FORM_STARTED = 'FORM_STARTED',
  SUMMARY_VIEWED = 'SUMMARY_VIEWED',
  BOOKING_CREATED = 'BOOKING_CREATED',
  FIRST_PAYMENT = 'FIRST_PAYMENT',
}

/**
 * Barwy idą od szarości do zieleni „gotowe” — im dalej w lejku, tym mocniejszy
 * kolor, więc zwężanie się strumienia widać bez czytania liczb.
 */
export const FUNNEL_STAGE_REGISTRY: Record<
  string,
  { label: string; color: string }
> = {
  [FunnelStageKey.OFFER_VIEWED]: {
    label: 'Wejścia na ofertę',
    color: CHART_PALETTE.reference,
  },
  [FunnelStageKey.FORM_STARTED]: {
    label: 'Wypełnianie formularza',
    color: CHART_PALETTE.muted,
  },
  [FunnelStageKey.SUMMARY_VIEWED]: {
    label: 'Podsumowanie',
    color: CHART_PALETTE.accentLight,
  },
  [FunnelStageKey.BOOKING_CREATED]: {
    label: 'Rezerwacje',
    color: CHART_PALETTE.accent,
  },
  [FunnelStageKey.FIRST_PAYMENT]: {
    label: 'Pierwsza wpłata',
    color: STATUS_TONE_COLORS.success.dot,
  },
};
